var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Currency',{class:_vm.pacingClass,attrs:{"value":_vm.seat.amount_fulfilled,"mantissa":2}})
}
var staticRenderFns = []

export { render, staticRenderFns }